import React from "react";
import ModalAction from "./ModalAction";
import LoadingIcon from "../assets/images/loading-icon.svg";

export default function ModalLoading({ showModal, setShowModal }) {
  return (
    <ModalAction
      id="loading-modal"
      modalOpen={showModal}
      setModalOpen={setShowModal}
    >
      {/* Modal header */}
      <div className="py-5 flex flex-col justify-center items-center text-center space-y-1">
        {/* Icon */}
        <div className="inline-flex animate-bounce">
          <img src={LoadingIcon} className="w-12 h-12" alt="Announcement" />
        </div>
        <div className="text-lg font-semibold text-gray-700 ">
          Please Wait...
        </div>
      </div>
    </ModalAction>
  );
}
